/**
 * Check if user has System Admin role
 * @param {Object} user - User object from Redux store
 * @returns {boolean} - True if user has System Admin role
 */
export const isSystemAdmin = (user) => {
  if (!user || !user.roles || !Array.isArray(user.roles)) {
    return false;
  }
  
  // Check if roles array contains "System Admin" (case-insensitive)
  return user.roles.some(
    (role) => role && role.toLowerCase() === "system admin"
  );
};
